module.exports = __webpack_public_path__ + "static/media/wind.1e0854e6.svg";